/**
 * LegalForms Class
 */
export class LegalForms {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.scene = document.querySelector( containerEl );

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const forms = document.querySelectorAll( '.js-custom-validation-form' );

		if ( forms.length > 0 ) {

			forms.forEach( ( form ) => {

				const fields = form.querySelectorAll( '*[aria-required="true"]' );
				form.classList.add( 'is-disabled' );

				form.addEventListener( 'change', ( ) => {

					let counter = fields.length;

					if ( fields.length > 0 ) {

						fields.forEach( ( field ) => {

							if ( field.value.length < 1 ) {

								form.classList.add( 'is-disabled' );
								//counter++;

							} else {

								counter--;

							}

						} );

						if ( counter === 0 ) {

							form.classList.remove( 'is-disabled' );

						}

						/* eslint-disable */
                        console.log(counter);
                        /* eslint-enable */

					}

				} );

				form.addEventListener( 'mouseover', () => {

					form.querySelector( '.wpcf7-submit' ).disabled = false;
					form.querySelector( '.wpcf7-submit' ).removeAttribute( 'disabled' );

				} );

			} );

		}

	}

}
